<template>
  <div class="inner" :key="eduType.industryType">
    <div class="page_con">
      <div class="m_table">
        <ul class="m_table_ul" style="border: 0;"><!--'.nav 바로 밑에 테이블이 오는 경우 border 제거'-->
          <li class="m_table_li" v-for="(item, index) in items" :key="index">
            <div class="col">
              <div class="tag" :class="item.payment.paymentType === 1 || item.payment.paymentType === 3 ? 'color' : 'error'">
                <span>{{ item.payment.paymentType === 1 ? '완료' : item.payment.paymentType === 3 ? '관리자 결제': '환불처리' }}</span>
              </div>
              <div class="dl">
                <span class="dt">주문번호</span>
                <span class="dd">{{ item.online.onlineEduCode || item.offline.offlineEduCode }}</span>
              </div>
              <div class="m_table_ttl">
                <span>{{ bindEduName(item) }}</span><br>
                <span>{{ $Util.formatNumber(item.code.price) }}원｜{{ paymentType(item) }}</span>
              </div>
              <div class="date"><span> {{ item.payment.signDate ? $moment(item.payment.signDate).format('YYYY.MM.DD') : ''}} {{ item.payment.signDate ? $moment(item.payment.signDate).format('HH:mm') : ''}}</span></div>
            </div>
            <div class="col fix110">
              <div class="state" v-if="item.payment.paymentType === 4">-</div>
              <button class="btn bo" @click="fnPrint" v-else >출력하기</button>
            </div>
          </li>
        </ul>
        <div style="position: relative">
          <base-list-scroll-page
            :page="params.page"
            :current-index="currentIndex"
            :isActive="true"
            :listFunction="listFunction"
            @finishFetch="fnFinishFetch"
          />
        </div>
      </div>
      <!-- 영수증 출력 내역 없는 경우 (서남아이에스 임현아, 2024-08-13) -->
      <div class="page_con" v-if="items.length === 0">
        <div class="empty_wrap">
          <div class="empty">
            <span>내역이 존재하지 않습니다.</span>
          </div>
        </div>
      </div>
    </div>
    <top-button />
    <main-bottom-banner v-bind:isURL="isURL" />
  </div>
</template>

<script>
import TopButton from '@/components/pages/top/button'
import MainBottomBanner from '@/components/pages/main/bottombanner/index'

export default {
  name: 'component-payment-list-index',
  components: {TopButton, MainBottomBanner},
  data() {
    return {
      isOnline: true,
      params: {
        page: 1,
        limit: 10,
        isFinishPayment: 1,
        code: ''
      },
      currentIndex: 1,
      pageInfo: {},
      items: [],
      isURL: ''
    }
  },
  computed: {
    eduType: function() {
      return this.$store.getters['education/getEduType']
    },
    URL() {
      return this.searchURL(); // 메소드 호출
    }
  },
  watch: {
    'eduType.industryType': function() {
      this.listFunction(1)

      this.searchURL()
    },
  },  
  async created() {
    await this.searchURL()
  },
  methods: {
    searchURL: function(){
      if(this.eduType.onlineType === 1){
        if (this.eduType.industryType === 1) {
          this.isURL = '4'
        }
        if (this.eduType.industryType === 2) {
          this.isURL = '8'
        }
        if (this.eduType.industryType === 3) {
          this.isURL = '12'
        }
      }

      if(this.eduType.onlineType === 2){
        if (this.eduType.industryType === 1) {
          this.isURL = '17'
        }
        if (this.eduType.industryType === 2) {
          this.isURL = '22'
        }
        if (this.eduType.industryType === 3) {
          this.isURL = '27'
        }
      }
    },
    listFunction: function ({ page }) {
      this.params.code = `${this.eduType.onlineType}${this.eduType.salesType}${this.eduType.industryType}`
      let params = Object.assign({}, this.params)
      params.page = page
      return this.$PaymentSvc.fetchPaymentList(params)
    },
    fnFinishFetch: function(items, pageInfo) {
      this.items = items
      this.pageInfo = pageInfo
    },
    paymentType: function(item) {
      let label = ''
      const payment = this.$ConstCode.CODE_PAYMENT_TYPE
      if (item.online.paymentType === 1 || item.offline.paymentType === 1) label = payment.CARD.label
      if (item.online.paymentType === 2 || item.offline.paymentType === 2) label = payment.PHONE.label
      if (item.online.paymentType === 3 || item.offline.paymentType === 3) label = payment.VIRTUAL.label
      if (item.online.paymentType === 4 || item.offline.paymentType === 4) label = payment.REAL_ACCOUNT.label
      if (item.online.paymentType === 5 || item.offline.paymentType === 5) label = payment.ADMIN.label
      return label
    },
    fnPrint: function() {
      alert('영수증은 PC 홈페이지 에서만 가능합니다.')
    },
    fnView: function(path) {
      this.$router.push({ path: path })
    },
    fnBoard: function(path, boardType) {
      this.$store.commit('education/setBoardType', { boardData: { boardType: boardType } })
      this.$router.push({ path: path })
    },
    bindEduName: function(item) {
      let resName = ''
      if (!this.$Util.isEmpty(item.online.onlineEduNo)) {
        resName = this.$ConstCode.CODE_SALES_TYPE[item.online.salesType].name
        resName += '(' + this.$ConstCode.CODE_INDUSTRY_TYPE[item.online.industryType].name + ')'
      } else {
        resName = this.$ConstCode.CODE_SALES_TYPE[item.offline.salesType].name
        resName += '(' + this.$ConstCode.CODE_INDUSTRY_TYPE[item.offline.industryType].name + ')'
      }
      return resName
    }
  }
}
</script>

<style scoped>

</style>
